import * as Yup from 'yup';
import { useState } from 'react';
import { Icon } from '@iconify/react';
import { useFormik, Form, FormikProvider } from 'formik';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SaveIcon from '@material-ui/icons/Save';
import { useNavigate } from 'react-router-dom';
import faker from 'faker';

import {
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Card,
  CardContent,
  Grid,
  Divider,
  FormControl,
  Box,
  Button,
  CircularProgress,
  Backdrop
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { firebaseStore } from '../../../storage/base';
// import { useClientContext } from '../../../context/client_context';
import { baseUrl, employers, deductionType } from '../../../utils/constants';
import Controls from '../../controls/Controls';

export default function SelfRegForm() {
  // const { clientRefId, currentClient, setClientRefId, setCurrentClient } = useClientContext();
  const navigate = useNavigate();
  const d = new Date();
  d.setMonth(d.getMonth() + 1, 1);
  const [showPassword, setShowPassword] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [loading, setLoading] = useState(false);
  const [errorsShow, setErrors] = useState('');
  const customerIdentifier = faker.datatype.uuid();

  const RegisterSchema = Yup.object().shape({
    ecNumber: Yup.string()
      .required('EC Number is Required')
      .min(8, 'EC Number must be 8 Charecters only')
      .max(8, 'EC Number must be 8 Charecters only')
      .matches(
        /^\b([0-9]){7}([a-zA-Z]){1}\b/,
        'EC Number starts with 7 number digits and 1 Charecter at end'
      ),
    firstName: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('First name required'),
    surname: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Last name required'),
    cellNumber: Yup.string().required('Cell number is required'),
    idNumber: Yup.string()
      .required('ID number is required')
      .matches(
        /^([0-9]{8,9}[a-z,A-Z][0-9]{2})$/,
        'Id Number must contain at least 11 or 12 characters and 1(one) letter'
      ),
    reference: Yup.string().required('Reference is required'),
    reason: Yup.string().required('Reason for deduction is required'),
    station: Yup.string().required('Station is required'),
    dist: Yup.string().required('District is required'),
    startDate: Yup.date().required('Start Date is required'),
    endDate: Yup.date().required('End Date is required'),
    emailAddress: Yup.string()
      .email('Email must be a valid email address')
      .required('Email is required'),
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match')
      .required('Please re-type password'),
    dpt: Yup.string()
      .required()
      .matches(/^[0-9]+$/, 'Must be only digits')
      .min(4, 'Must be exactly 4 digits')
      .max(4, 'Must be exactly 4 digits'),
    stn: Yup.string()
      .required()
      .matches(/^[0-9]+$/, 'Must be only digits')
      .min(4, 'Must be exactly 4 digits')
      .max(4, 'Must be exactly 4 digits'),
    idFilename: Yup.number().required('ID Document is required'),
    payslipFilename: Yup.number().required('Payslip Document  is required')
  });

  const formik = useFormik({
    initialValues: {
      ecNumber: '',
      firstName: '',
      surname: '',
      idNumber: '',
      dateOfBirth: '',
      gender: 'F',
      cellNumber: '',
      emailAddress: '',

      dpt: '',
      stn: '',
      station: '',
      dist: '',
      reference: 'SUBS',
      reason: 'Subscriptions and Provident fund',
      deductionType: 'New',
      startDate: d.toLocaleDateString('en-GB'),
      endDate: '',
      monthlyRate: 0,
      totalDue: 0,
      repaymentPeriod: 0,
      payslipFilename: '',
      idFilename: '',

      password: '',
      confirmPassword: '',
      loginType: 0,
      loginIdentifier: '',
      alternateLoginIdentifier: null,
      partnerRefId: 1,
      source: 'Web'
    },
    validationSchema: RegisterSchema,
    onSubmit: () => {
      formik.values.loginIdentifier = formik.values.emailAddress;
      checkClientExists(formik.values);
      console.log('Form data on Register', formik.values);
      // navigate('/dashboard', { replace: true });
    }
  });

  const handleFormUpdate = (e) => {
    saveClientData(e);
  };

  const handleFileUpload = (e, fileType) => {
    console.log('e file info', e);
    console.log('e fileType', fileType);
    const selectedFiles = Array.from(e.target.files);
    const totalSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);
    if (totalSize > 2 * 1024 * 1024) {
      notifyPopup(
        `Image size exceeds. It should be less than 2MB...! Current Size: ${
          totalSize / (1024 * 1024)
        } MB`,
        'error'
      );
    }
  };

  const checkClientExists = async (client) => {
    console.log('client.ecNumber', client.ecNumber);
    await fetch(`${baseUrl}/api/client/GetClientByEcNumber?ecNumber=${client.ecNumber}`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned reg client infosss', result);
          if (result.result === null || result.result === undefined) {
            saveClientData(client);
          } else {
            notifyPopup(
              `Client Already Exists.  You are already registered on the ZIMTA Database.  Please call +263242 795931..`,
              'error'
            );
            setErrors(
              'Client Already Exists.  You are already registered on the ZIMTA Database.  Please call +263242 795931..'
            );
          }
        },
        (error) => {
          alert('failed');
        }
      );
  };

  const saveClientData = (client) => {
    console.log('Form data in Save Register', client);
    const jsonClient = [];
    jsonClient.push(client);
    console.log('reg info stringified now', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/client/SaveClientQuick`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('from registration', result);
          if (result.replyStatus === 1) {
            notifyPopup(
              `Error in Saving Application.  Failed to Create Profile.  Please call +263242 795931..!: ${result.replyMessage}`,
              'error'
            );
          } else {
            notifyPopup(`Application Saved Successfully!`, 'success');
            moveToAccept();
          }
        },
        (error) => {
          notifyPopup(
            `Error in Saving Applicaiton.  Please contact nearest ZIMTA offices for assistance..!: ${error}`,
            'error'
          );
        }
      );
  };

  const handleSaveFile = (e, docType) => {
    // setShow(true);
    setLoading(true);
    const file = e.target.files;
    const selectedFiles = Array.from(e.target.files);
    const totalSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);
    if (totalSize > 2 * 1024 * 1024) {
      notifyPopup(
        `Image size exceeds. It should be less than 2MB...! Current Size: ${
          totalSize / (1024 * 1024)
        } MB`,
        'error'
      );
      return;
    }

    const fileNimo = customerIdentifier + file[0].name;
    console.log('original file name', fileNimo);
    const storageRef = firebaseStore.storage().ref();
    // const uploadTask = storageRef.child(file[0].name).put(file[0]);
    const uploadTask = storageRef.child(fileNimo).put(file[0]);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // setProgress(progress);
        console.log(`Upload is ${progress}% done`);
      },
      (error) => {
        notifyPopup(`Error in Uploading Document..!: ${error}`, 'error');
      },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          document.DocumentPath = downloadURL;
          document.OriginalFileName = file[0].name;
          document.DocumentFilename = `${customerIdentifier}_${file[0].name}`;
          document.OwnerIdentifier = customerIdentifier;
          document.DocumentType = docType;
          document.ClientRefId = 0;
          document.idNumber = formik.values.ecNumber;
          saveToDatabase(document);
        });
      }
    );
  };

  const saveToDatabase = (e) => {
    const jsonDoc = [];
    jsonDoc.push(e);
    console.log('document e', e);
    console.log('document stringified now', JSON.stringify(jsonDoc));
    fetch(`${baseUrl}/api/client/SaveDocumentNoClient`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonDoc[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('document result after save', result);
          console.log('DocumentType result after save', result.documentType);
          if (result.documentType === 1) {
            formik.setFieldValue('idFilename', result.refId);
            console.log('came in here', result.refId);
          }
          if (result.documentType === 2) formik.setFieldValue('payslipFilename', result.refId);
          console.log('current context idFilename', formik.values.idFilename);
          console.log('current context payslip', formik.values.payslipFilename);
          notifyPopup(`Document Uploaded Successfully!`, 'success');
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in Saving Document, Please try again..!: ${error}`, 'error');
        }
      );
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const moveToAccept = () => {
    navigate(`/signature`);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <Card>
      <Box>
        <Typography color="error" variant="h6">
          {errorsShow && <div>{errorsShow}</div>}
        </Typography>
      </Box>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
              onClick={handleLoadingClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              <Grid item xs={12} sm={4}>
                <Controls.Input name="ecNumber" label="EC #" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controls.SelectJson name="groupId" label="Province" options={employers} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controls.Input name="surname" label="Surname #" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controls.Input name="firstName" label="First Name" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="dpt" label="Dpt #" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="stn" label="Stn #" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="station" label="Station/School" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="dist" label="District" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controls.Input name="cellNumber" label="Cell Number" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controls.Input name="emailAddress" label="Email Address" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controls.Input name="idNumber" label="ID Number" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controls.DateTime name="dateOfBirth" label="Date of Birth" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Controls.SelectJson
                  name="deductionType"
                  label="Deduction Type"
                  options={deductionType}
                />
              </Grid>
              <Grid item xs={12} sm={4} justifyContent="center" alignItems="center">
                <Controls.Input name="reference" label="Reference" disabled />
              </Grid>
              <Grid item xs={12} sm={6} justifyContent="center" alignItems="center">
                <Controls.Input name="reason" label="Reason" disabled />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.DateTime name="startDate" label="Start Date" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.DateTime name="endDate" label="End Date" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.InputNumber name="monthlyRate" label="Monthly Rate" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.InputNumber name="totalDue" label="Total Due" />
              </Grid>
              <Grid item xs={12} sm={5} mb={2}>
                <Controls.InputNumber name="repaymentPeriod" label="Repayment Period" />
              </Grid>
              <Divider
                style={{ background: '#00000', height: 1, margin: 1, mt: '8px', width: '90%' }}
                variant="middle"
              />
              <Grid item xs={12} sm={5} ml={12}>
                <Button
                  component="label"
                  variant="outlined"
                  startIcon={<CloudUploadIcon />}
                  sx={{ marginRight: '1rem' }}
                  disabled={formik.values.idFilename > 0}
                >
                  Upload ID Card
                  <input
                    type="file"
                    accept="image/x-png,image/gif,image/jpeg,.pdf"
                    hidden
                    onChange={(e) => handleSaveFile(e, 1)}
                  />
                </Button>
                <Controls.Input
                  name="idFilename"
                  label="ID Filename"
                  variant="standard"
                  disabled
                  style={{
                    background: '#00000',
                    width: '40%'
                  }}
                  sx={{ border: 'none', '& fieldset': { border: 'none' } }}
                />
              </Grid>
              <Grid item xs={12} sm={5} ml={12}>
                <Button
                  component="label"
                  variant="outlined"
                  startIcon={<CloudUploadIcon />}
                  sx={{ marginRight: '1rem' }}
                  disabled={formik.values.payslipFilename > 0}
                >
                  Upload Payslip
                  <input
                    type="file"
                    accept="image/x-png,image/gif,image/jpeg,.pdf"
                    hidden
                    onChange={(e) => handleSaveFile(e, 2)}
                  />
                </Button>
                {/* <i>filename</i>
                <Box>{filename}</Box> */}
                <Controls.Input
                  name="payslipFilename"
                  label="Payslip Filename"
                  variant="standard"
                  disabled
                  style={{ background: '#00000', width: '40%' }}
                  sx={{ border: 'none', '& fieldset': { border: 'none' } }}
                />
              </Grid>
              <Divider
                style={{ background: '#00000', height: 1, margin: 1, mt: '8px', width: '90%' }}
                variant="middle"
                mt={2}
              />
              <Grid item xs={12} sm={4} mb={2}>
                <TextField
                  fullWidth
                  size="small"
                  autoComplete="current-password"
                  type={showPassword ? 'text' : 'password'}
                  label="Password"
                  {...getFieldProps('password')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                          <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                />
              </Grid>
              <Grid item xs={12} sm={4} mb={2}>
                <TextField
                  fullWidth
                  size="small"
                  autoComplete="confirm-password"
                  type={showPassword ? 'text' : 'password'}
                  label="Confirm Password"
                  {...getFieldProps('confirmPassword')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                          <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} justifyContent="center" alignItems="center" mt="2">
              <Grid item xs={12} sm={5} mt={2}>
                <Button
                  type="submit"
                  fullWidth
                  variant="outlined"
                  sx={{ minWidth: '60px', p: 1, px: 2, color: 'white', backgroundColor: '#000000' }}
                  startIcon={<SaveIcon />}
                >
                  Register
                </Button>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </CardContent>
      <Controls.Notification notify={notify} setNotify={setNotify} />
    </Card>
  );
}
